import {LOCALE_DE} from "../locales/locale_DE";
import {LOCALE_EN} from "../locales/locale_EN";
import {LOCALE_FR} from "../locales/locale_FR";
import {LOCALE_PL} from "../locales/locale_PL";
import {LOCALE_NL} from "../locales/locale_NL";
import {LOCALE_IT} from "../locales/locale_IT";
import {LOCALE_SE} from "../locales/locale_SE";
import {LOCALE_DK} from "../locales/locale_DK";
import {LOCALE_NO} from "../locales/locale_NO";
import {LOCALE_ES} from "../locales/locale_ES";

export function determineCurrentLocale(language) {
    if (!language) {
        return LOCALE_DE;
    }
    if (language === "GERMAN") {
        return LOCALE_DE;
    } else if (language === "ENGLISH") {
        return LOCALE_EN;
    } else if (language === "FRENCH") {
        return LOCALE_FR;
    } else if (language === "POLISH") {
        return LOCALE_PL;
    } else if (language === "DUTCH") {
        return LOCALE_NL;
    } else if (language === "ITALIAN") {
        return LOCALE_IT;
    } else if (language === "SPANISH") {
        return LOCALE_ES;
    } else if (language === "NORWAY") {
        return LOCALE_NO;
    } else if (language === "DANISH") {
        return LOCALE_DK;
    } else if (language === "SWEDISH") {
        return LOCALE_SE;
    } else {
        return LOCALE_DE;
    }
}
